import { ToolSideItem } from '@/features/tool/types/tools';
import {
  CONVERTIBLE_UPLOAD_FILE_TYPES,
  EXCEL_TO_PDF_FILE_TYPES,
  IMAGE_TO_PDF_FILE_TYPES,
  MERGE_PDF_FILE_TYPES,
  PDF_TO_EXCEL_FILE_TYPES,
  PDF_TO_IMAGE_FILE_TYPES,
  PDF_TO_POWERPOINT_FILE_TYPES,
  PDF_TO_WORD_FILE_TYPES,
  PDF_ONLY_FILE_TYPES,
  POWERPOINT_TO_PDF_FILE_TYPES,
  WORD_TO_PDF_FILE_TYPES,
} from '@/features/tool/utils/uploadConstraints';

export const getMostPopularPDFtoolsMenu = (t: (key: string) => string) => [
  {
    icon: 'CompressPdf24',
    title: t('dashboard.tools.compress.title'),
    url: '/compress',
    description: t('dashboard.tools.compress.description'),
    status: 'available',
    dashboardUrl: '/app/compress-pdf?tool=compress',
  },
  {
    icon: 'Word',
    title: t('dashboard.tools.pdf-to-word.title'),
    url: '/pdf-to-word-converter',
    description: t('dashboard.tools.pdf-to-word.description'),
    status: 'available',
    dashboardUrl: '/app/convert-pdf?tool=pdf-to-word',
  },
  {
    icon: 'JpegToPdf24',
    title: t('dashboard.tools.pdf-to-jpg.title'),
    url: 'pdf-to-image-converter',
    description: t('dashboard.tools.pdf-to-jpg.description'),
    status: 'available',
    dashboardUrl: '/app/convert-pdf?tool=pdf-to-jpg',
  },
  {
    icon: 'PdfAnnotator',
    url: '/pdf-annotator',
    title: t('dashboard.tools.annotate-pdf.title'),
    description: t('dashboard.tools.annotate-pdf.description'),
    status: 'available',
    dashboardUrl: '/app/edit-pdf?tool=annotate-pdf',
  },
  {
    icon: 'Excel',
    title: t('dashboard.tools.pdf-to-excel.title'),
    url: '/pdf-to-excel-converter',
    description: t('dashboard.tools.pdf-to-excel.description'),
    status: 'available',
    dashboardUrl: '/app/convert-pdf?tool=pdf-to-excel',
  },
  {
    icon: 'ESignPdf24',
    title: t('dashboard.tools.sign.title'),
    description: t('dashboard.tools.sign.description'),
    status: 'available',
    dashboardUrl: '/app/sign-pdf?tool=sign',
  },
  {
    icon: 'PowerPoint',
    title: t('dashboard.tools.pdf-to-ppt.title'),
    url: '/pdf-to-ppt-converter',
    description: t('dashboard.tools.pdf-to-ppt.description'),
    status: 'available',
    dashboardUrl: '/app/convert-pdf?tool=pdf-to-ppt',
  },
  {
    icon: 'PdfConverter24',
    title: t('dashboard.tools.convert-pdf.title'),
    description: t('dashboard.tools.convert-pdf.description'),
    status: 'available',
    dashboardUrl: '/app/convert-pdf?tool=convert-pdf',
  },
];

export const getOtherPDFtoolsMenu = (t: (key: string) => string) => [
  {
    icon: 'MergePdf',
    title: t('dashboard.tools.merge-pdf.title'),
    description: t('dashboard.tools.merge-pdf.description'),
    status: 'available',
    dashboardUrl: '/app/organize-pdf?tool=merge-pdf',
  },
  {
    icon: 'DeletePdfPages',
    title: t('dashboard.tools.delete-pdf-pages.title'),
    description: t('dashboard.tools.delete-pdf-pages.description'),
    status: 'available',
    dashboardUrl: '/app/organize-pdf?tool=delete-pdf-pages',
  },

  {
    icon: 'RotatePdf24',
    title: t('dashboard.tools.rotate-pdf.title'),
    description: t('dashboard.tools.rotate-pdf.description'),
    status: 'available',
    dashboardUrl: '/app/organize-pdf?tool=rotate-pdf',
  },
  {
    icon: 'UnlockPdf',
    title: t('dashboard.tools.unlock-pdf.title'),
    description: t('dashboard.tools.unlock-pdf.description'),
    status: 'available',
    dashboardUrl: '/app/edit-pdf?tool=unlock-pdf',
  },
  {
    icon: 'EditPdf24',
    title: t('dashboard.tools.edit-pdf.title'),
    url: '/pdf-editor',
    description: t('dashboard.tools.edit-pdf.description'),
    status: 'available',
    dashboardUrl: '/app/edit-pdf?tool=edit-pdf',
  },
  {
    icon: 'SplitPdf',
    title: t('dashboard.tools.split-pdf.title'),
    description: t('dashboard.tools.split-pdf.description'),
    status: 'available',
    dashboardUrl: '/app/organize-pdf?tool=split-pdf',
  },
  {
    icon: 'ProtectPdf',
    title: t('dashboard.tools.protect-pdf.title'),
    tooltip: 'Add security to your PDF files',
    description: t('dashboard.tools.protect-pdf.description'),
    status: 'available',
    dashboardUrl: '/app/edit-pdf?tool=protect-pdf',
  },
];

export const MENU = (t: (key: string) => string = (key: string) => key) => [
  {
    name: t('tools_data.menu.compress.name'),
    tools: [
      {
        bgColor: 'hover:bg-[#F43F3F]',
        icon: 'CompressPdf24',
        title: t('tools_data.menu.compress.tools.compress_pdf.title'),
        url: '/compress',
        description: t(
          'tools_data.menu.compress.tools.compress_pdf.description'
        ),
        tooltip: t('tools_data.menu.compress.tools.compress_pdf.tooltip'),
        status: 'available',
        dashboardUrl: '/app/compress-pdf?tool=compress',
      },
    ],
  },
  {
    name: t('tools_data.menu.convert.name'),
    tools: [
      {
        bgColor: 'hover:bg-[#F43F3F]',
        icon: 'PdfConverter24',
        title: t('tools_data.menu.convert.tools.pdf_converter.title'),
        tooltip: t('tools_data.menu.convert.tools.pdf_converter.tooltip'),
        description: t(
          'tools_data.menu.convert.tools.pdf_converter.description'
        ),
        status: 'available',
        dashboardUrl: '/app/convert-pdf?tool=convert-pdf',
        url: '/pdf-converter',
      },
    ],
  },
  {
    name: t('tools_data.menu.ai_pdf.name'),
    tools: [
      {
        bgColor: 'hover:bg-[#35C2FF]',
        icon: 'ChatWithPdf',
        title: t('tools_data.menu.ai_pdf.tools.chat_with_pdf.title'),
        tooltip: t('tools_data.menu.ai_pdf.tools.chat_with_pdf.tooltip'),
        description: t(
          'tools_data.menu.ai_pdf.tools.chat_with_pdf.description'
        ),
        status: 'coming_soon',
        dashboardUrl: '/app/ai-pdf?tool=chat-with-pdf',
        url: '/chat-with-pdf',
      },
      {
        bgColor: 'hover:bg-[#35C2FF]',
        icon: 'AiPdfSummarizer',
        title: t('tools_data.menu.ai_pdf.tools.ai_pdf_summarizer.title'),
        tooltip: t('tools_data.menu.ai_pdf.tools.ai_pdf_summarizer.tooltip'),
        description: t(
          'tools_data.menu.ai_pdf.tools.ai_pdf_summarizer.description'
        ),
        status: 'coming_soon',
        dashboardUrl: '/app/ai-pdf?tool=ai-pdf-summarizer',
        url: '/ai-pdf-summarizer',
      },
      {
        bgColor: 'hover:bg-[#35C2FF]',
        icon: 'TranslatePdf',
        title: t('tools_data.menu.ai_pdf.tools.translate_pdf.title'),
        tooltip: t('tools_data.menu.ai_pdf.tools.translate_pdf.tooltip'),
        description: t(
          'tools_data.menu.ai_pdf.tools.translate_pdf.description'
        ),
        status: 'coming_soon',
        dashboardUrl: '/app/ai-pdf?tool=translate-pdf',
        url: '/translate-pdf',
      },
    ],
  },
  {
    name: t('tools_data.menu.organize.name'),
    tools: [
      {
        bgColor: 'hover:bg-[#AA67FF]',
        icon: 'RotatePdf24',
        title: t('tools_data.menu.organize.tools.rotate_pdf.title'),
        tooltip: t('tools_data.menu.organize.tools.rotate_pdf.tooltip'),
        description: t('tools_data.menu.organize.tools.rotate_pdf.description'),
        status: 'available',
        dashboardUrl: '/app/organize-pdf?tool=rotate-pdf',
        url: '/rotate-pdf',
      },
      {
        bgColor: 'hover:bg-[#AA67FF]',
        icon: 'SplitPdf',
        title: t('tools_data.menu.organize.tools.split_pdf.title'),
        tooltip: t('tools_data.menu.organize.tools.split_pdf.tooltip'),
        description: t('tools_data.menu.organize.tools.split_pdf.description'),
        status: 'available',
        dashboardUrl: '/app/organize-pdf?tool=split-pdf',
        url: '/split-pdf',
      },
      {
        bgColor: 'hover:bg-[#AA67FF]',
        icon: 'MergePdf',
        title: t('tools_data.menu.organize.tools.merge_pdf.title'),
        tooltip: t('tools_data.menu.organize.tools.merge_pdf.tooltip'),
        description: t('tools_data.menu.organize.tools.merge_pdf.description'),
        status: 'available',
        dashboardUrl: '/app/organize-pdf?tool=merge-pdf',
        url: '/merge-pdf',
      },
      {
        bgColor: 'hover:bg-[#AA67FF]',
        icon: 'DeletePdfPages',
        title: t('tools_data.menu.organize.tools.delete_pdf_pages.title'),
        tooltip: t('tools_data.menu.organize.tools.delete_pdf_pages.tooltip'),
        description: t(
          'tools_data.menu.organize.tools.delete_pdf_pages.description'
        ),
        status: 'available',
        dashboardUrl: '/app/organize-pdf?tool=delete-pdf-pages',
        url: '/delete-pdf-pages',
      },
      {
        bgColor: 'hover:bg-[#AA67FF]',
        icon: 'ExtractPdfPages',
        title: t('tools_data.menu.organize.tools.extract_pdf_pages.title'),
        tooltip: t('tools_data.menu.organize.tools.extract_pdf_pages.tooltip'),
        description: t(
          'tools_data.menu.organize.tools.extract_pdf_pages.description'
        ),
        status: 'available',
        dashboardUrl: '/app/organize-pdf?tool=extract-pdf-pages',
        url: '/extract-pdf-pages',
      },
    ],
  },
  {
    name: t('tools_data.menu.view_edit.name'),
    tools: [
      {
        bgColor: 'hover:bg-[#1BCFC4]',
        icon: 'EditPdf24',
        title: t('tools_data.menu.view_edit.tools.edit_pdf.title'),
        url: '/pdf-editor',
        tooltip: t('tools_data.menu.view_edit.tools.edit_pdf.tooltip'),
        description: t('tools_data.menu.view_edit.tools.edit_pdf.description'),
        status: 'available',
        dashboardUrl: '/app/edit-pdf?tool=edit-pdf',
        isPro: true,
      },
      {
        bgColor: 'hover:bg-[#1BCFC4]',
        icon: 'PdfAnnotator',
        url: '/pdf-annotator',
        title: t('tools_data.menu.view_edit.tools.pdf_annotator.title'),
        tooltip: t('tools_data.menu.view_edit.tools.pdf_annotator.tooltip'),
        description: t(
          'tools_data.menu.view_edit.tools.pdf_annotator.description'
        ),
        status: 'available',
        dashboardUrl: '/app/edit-pdf?tool=annotate-pdf',
      },
      {
        bgColor: 'hover:bg-[#1BCFC4]',
        icon: 'CropPdf',
        title: t('tools_data.menu.view_edit.tools.crop_pdf.title'),
        tooltip: t('tools_data.menu.view_edit.tools.crop_pdf.tooltip'),
        description: t('tools_data.menu.view_edit.tools.crop_pdf.description'),
        status: 'coming_soon',
        dashboardUrl: '/app/edit-pdf?tool=crop-pdf',
        url: '/crop-pdf',
      },
      {
        bgColor: 'hover:bg-[#1BCFC4]',
        icon: 'PdfReader',
        title: t('tools_data.menu.view_edit.tools.pdf_reader.title'),
        tooltip: t('tools_data.menu.view_edit.tools.pdf_reader.tooltip'),
        description: t(
          'tools_data.menu.view_edit.tools.pdf_reader.description'
        ),
        status: 'coming_soon',
        dashboardUrl: '/app/edit-pdf?tool=pdf-reader',
        url: '/pdf-reader',
      },
      {
        bgColor: 'hover:bg-[#1BCFC4]',
        icon: 'NumberPages',
        title: t('tools_data.menu.view_edit.tools.number_pages.title'),
        tooltip: t('tools_data.menu.view_edit.tools.number_pages.tooltip'),
        description: t(
          'tools_data.menu.view_edit.tools.number_pages.description'
        ),
        status: 'coming_soon',
        dashboardUrl: '/app/edit-pdf?tool=number-pages',
        url: '/number-pages',
      },
      {
        bgColor: 'hover:bg-[#1BCFC4]',
        icon: 'RedactPdf',
        title: t('tools_data.menu.view_edit.tools.redact_pdf.title'),
        tooltip: t('tools_data.menu.view_edit.tools.redact_pdf.tooltip'),
        description: t(
          'tools_data.menu.view_edit.tools.redact_pdf.description'
        ),
        status: 'coming_soon',
        dashboardUrl: '/app/edit-pdf?tool=redact-pdf',
        url: '/redact-pdf',
      },

      {
        bgColor: 'hover:bg-[#1BCFC4]',
        icon: 'WatermarkPdf',
        title: t('tools_data.menu.view_edit.tools.watermark_pdf.title'),
        tooltip: t('tools_data.menu.view_edit.tools.watermark_pdf.tooltip'),
        description: t(
          'tools_data.menu.view_edit.tools.watermark_pdf.description'
        ),
        status: 'coming_soon',
        dashboardUrl: '/app/edit-pdf?tool=watermark-pdf',
        url: '/watermark-pdf',
      },
    ],
  },
  {
    name: t('tools_data.menu.convert_to_pdf.name'),
    tools: [
      {
        bgColor: 'hover:bg-[#4B7EFF]',
        icon: 'Word',
        title: t('tools_data.menu.convert_to_pdf.tools.word_to_pdf.title'),
        url: '/word-to-pdf-converter',
        tooltip: t('tools_data.menu.convert_to_pdf.tools.word_to_pdf.tooltip'),
        description: t(
          'tools_data.menu.convert_to_pdf.tools.word_to_pdf.description'
        ),
        status: 'available',
        dashboardUrl: '/app/convert-pdf?tool=word-to-pdf',
      },
      {
        icon: 'Excel',
        bgColor: 'hover:bg-[#1BCF63]',
        url: '/excel-to-pdf-converter',
        title: t('tools_data.menu.convert_to_pdf.tools.excel_to_pdf.title'),
        tooltip: t('tools_data.menu.convert_to_pdf.tools.excel_to_pdf.tooltip'),
        description: t(
          'tools_data.menu.convert_to_pdf.tools.excel_to_pdf.description'
        ),
        status: 'available',
        dashboardUrl: '/app/convert-pdf?tool=excel-to-pdf',
      },
      {
        icon: 'PowerPoint',
        bgColor: 'hover:bg-[#FF7A00]',
        title: t(
          'tools_data.menu.convert_to_pdf.tools.powerpoint_to_pdf.title'
        ),
        url: '/ppt-to-pdf-converter',
        tooltip: t(
          'tools_data.menu.convert_to_pdf.tools.powerpoint_to_pdf.tooltip'
        ),
        description: t(
          'tools_data.menu.convert_to_pdf.tools.powerpoint_to_pdf.description'
        ),
        status: 'available',
        dashboardUrl: '/app/convert-pdf?tool=ppt-to-pdf',
      },
      {
        icon: 'JpegToPdf24',
        bgColor: 'hover:bg-[#F4AC3F]',
        url: '/image-to-pdf-converter',
        title: t('tools_data.menu.convert_to_pdf.tools.image_to_pdf.title'),
        tooltip: t('tools_data.menu.convert_to_pdf.tools.image_to_pdf.tooltip'),
        description: t(
          'tools_data.menu.convert_to_pdf.tools.image_to_pdf.description'
        ),
        status: 'available',
        dashboardUrl: '/app/convert-pdf?tool=jpg-to-pdf',
      },
      {
        icon: 'PdfOcr',
        bgColor: 'hover:bg-[#F43F3F]',
        title: t('tools_data.menu.convert_to_pdf.tools.pdf_ocr.title'),
        tooltip: t('tools_data.menu.convert_to_pdf.tools.pdf_ocr.tooltip'),
        description: t(
          'tools_data.menu.convert_to_pdf.tools.pdf_ocr.description'
        ),
        status: 'coming_soon',
        dashboardUrl: '/app/convert-pdf?tool=pdf-ocr',
        url: '/pdf-ocr',
      },
    ],
  },
  {
    name: t('tools_data.menu.convert_from_pdf.name'),
    tools: [
      {
        bgColor: 'hover:bg-[#4B7EFF]',
        icon: 'Word',
        title: t('tools_data.menu.convert_from_pdf.tools.pdf_to_word.title'),
        url: '/pdf-to-word-converter',
        tooltip: t(
          'tools_data.menu.convert_from_pdf.tools.pdf_to_word.tooltip'
        ),
        description: t(
          'tools_data.menu.convert_from_pdf.tools.pdf_to_word.description'
        ),
        status: 'available',
        dashboardUrl: '/app/convert-pdf?tool=pdf-to-word',
      },
      {
        bgColor: 'hover:bg-[#1BCF63]',
        icon: 'Excel',
        title: t('tools_data.menu.convert_from_pdf.tools.pdf_to_excel.title'),
        url: '/pdf-to-excel-converter',
        tooltip: t(
          'tools_data.menu.convert_from_pdf.tools.pdf_to_excel.tooltip'
        ),
        description: t(
          'tools_data.menu.convert_from_pdf.tools.pdf_to_excel.description'
        ),
        status: 'available',
        dashboardUrl: '/app/convert-pdf?tool=pdf-to-excel',
      },
      {
        bgColor: 'hover:bg-[#FF7A00]',
        icon: 'PowerPoint',
        title: t(
          'tools_data.menu.convert_from_pdf.tools.pdf_to_powerpoint.title'
        ),
        url: '/pdf-to-ppt-converter',
        tooltip: t(
          'tools_data.menu.convert_from_pdf.tools.pdf_to_powerpoint.tooltip'
        ),
        description: t(
          'tools_data.menu.convert_from_pdf.tools.pdf_to_powerpoint.description'
        ),
        status: 'available',
        dashboardUrl: '/app/convert-pdf?tool=pdf-to-ppt',
      },
      {
        bgColor: 'hover:bg-[#F4AC3F]',
        icon: 'JpegToPdf24',
        title: t('tools_data.menu.convert_from_pdf.tools.pdf_to_image.title'),
        url: 'pdf-to-image-converter',
        tooltip: t(
          'tools_data.menu.convert_from_pdf.tools.pdf_to_image.tooltip'
        ),
        description: t(
          'tools_data.menu.convert_from_pdf.tools.pdf_to_image.description'
        ),
        status: 'available',
        dashboardUrl: '/app/convert-pdf?tool=pdf-to-jpg',
      },
    ],
  },
  {
    name: t('tools_data.menu.sign.name'),
    tools: [
      {
        bgColor: 'hover:bg-[#F43FE2]',
        icon: 'ESignPdf24',
        title: t('tools_data.menu.sign.tools.esign_pdf.title'),
        tooltip: t('tools_data.menu.sign.tools.esign_pdf.tooltip'),
        description: t('tools_data.menu.sign.tools.esign_pdf.description'),
        status: 'available',
        dashboardUrl: '/app/sign-pdf?tool=sign',
        url: '/esign-pdf',
      },
    ],
  },
  {
    name: t('tools_data.menu.more.name'),
    tools: [
      {
        bgColor: 'hover:bg-[#FF678C]',
        icon: 'UnlockPdf',
        title: t('tools_data.menu.more.tools.unlock_pdf.title'),
        tooltip: t('tools_data.menu.more.tools.unlock_pdf.tooltip'),
        description: t('tools_data.menu.more.tools.unlock_pdf.description'),
        status: 'available',
        dashboardUrl: '/app/edit-pdf?tool=unlock-pdf',
        url: '/unlock-pdf',
      },
      {
        bgColor: 'hover:bg-[#FF678C]',
        icon: 'ProtectPdf',
        title: t('tools_data.menu.more.tools.protect_pdf.title'),
        tooltip: t('tools_data.menu.more.tools.protect_pdf.tooltip'),
        description: t('tools_data.menu.more.tools.protect_pdf.description'),
        status: 'available',
        dashboardUrl: '/app/edit-pdf?tool=protect-pdf',
        url: '/protect-pdf',
      },
      {
        bgColor: 'hover:bg-[#FF678C]',
        icon: 'FlattenPdf',
        title: t('tools_data.menu.more.tools.flatten_pdf.title'),
        tooltip: t('tools_data.menu.more.tools.flatten_pdf.tooltip'),
        description: t('tools_data.menu.more.tools.flatten_pdf.description'),
        status: 'coming_soon',
        dashboardUrl: '/app/more?tool=flatten-pdf',
        url: '/flatten-pdf',
      },
    ],
  },
];

export const getToolSideList = (t: (key: string) => string): ToolSideItem[] => [
  {
    key: 'compress',
    title: t('Tools.compress.title'),
    meta: {
      title: t('Tools.compress.meta.title'),
      description: t('Tools.compress.meta.description'),
    },
    otherLinks: [
      'compress',
      'compress-pdf',
      'compress-file',
      'reduce-file-size',
    ],
    link: '/compress-pdf',
    icon: 'CompressSide' as const,
    className: '[&_path]:stroke-[#F43F3F]',
    toolInfo: {
      title: t('Tools.compress.toolInfo.title'),
      description: t('Tools.compress.toolInfo.description'),
    },
    acceptedInput: PDF_ONLY_FILE_TYPES,
    outputForInput: {
      pdf: 'pdf',
      docx: 'pdf',
      doc: 'pdf',
      xlsx: 'pdf',
      xls: 'pdf',
      pptx: 'pdf',
      ppt: 'pdf',
      jpeg: 'pdf',
      jpg: 'pdf',
      png: 'pdf',
    },
  },
  {
    key: 'convert',
    title: t('Tools.convert.title'),
    link: '/convert-pdf',
    otherLinks: ['pdf-converter'],
    icon: 'ConvertSide' as const,
    className: '[&_path]:stroke-[#F43F3F]',
    subMenu: [
      {
        key: 'pdf-converter',
        meta: {
          title: t('Tools.convert.subMenu.pdfConverter.meta.title'),
          description: t('Tools.convert.subMenu.pdfConverter.meta.description'),
        },
        icon: 'PdfConverter24' as const,
        title: t('Tools.convert.subMenu.pdfConverter.title'),
        link: 'convert-pdf',
        otherLinks: ['pdf-converter'],
        toolInfo: {
          title: t('Tools.convert.subMenu.pdfConverter.toolInfo.title'),
          description: t(
            'Tools.convert.subMenu.pdfConverter.toolInfo.description'
          ),
        },
        acceptedInput: CONVERTIBLE_UPLOAD_FILE_TYPES,
        outputForInput: {
          pdf: '',
          docx: 'pdf',
          doc: 'pdf',
          xlsx: 'pdf',
          xls: 'pdf',
          pptx: 'pdf',
          ppt: 'pdf',
          jpeg: 'pdf',
          jpg: 'pdf',
          png: 'pdf',
        },
      },
      {
        key: 'pdf-to-word',
        icon: 'Word' as const,
        title: t('Tools.convert.subMenu.pdfToWord.title'),
        meta: {
          title: t('Tools.convert.subMenu.pdfToWord.meta.title'),
          description: t('Tools.convert.subMenu.pdfToWord.meta.description'),
        },
        link: 'pdf-to-word',
        otherLinks: ['pdf-to-word-converter'],
        toolInfo: {
          title: t('Tools.convert.subMenu.pdfToWord.toolInfo.title'),
          description: t(
            'Tools.convert.subMenu.pdfToWord.toolInfo.description'
          ),
        },
        acceptedInput: PDF_TO_WORD_FILE_TYPES,
        outputForInput: {
          pdf: 'docx',
        },
      },
      {
        key: 'word-to-pdf',
        icon: 'Word' as const,
        title: t('tools_data.menu.convert_to_pdf.tools.word_to_pdf.title'),
        meta: {
          title: t('tools_data.menu.convert_to_pdf.tools.word_to_pdf.title'),
          description: t(
            'tools_data.menu.convert_to_pdf.tools.word_to_pdf.description'
          ),
        },
        link: 'word-to-pdf',
        otherLinks: ['word-to-pdf-converter'],
        toolInfo: {
          title: t('tools_data.menu.convert_to_pdf.tools.word_to_pdf.title'),
          description: t(
            'tools_data.menu.convert_to_pdf.tools.word_to_pdf.description'
          ),
        },
        acceptedInput: WORD_TO_PDF_FILE_TYPES,
        outputForInput: {
          docx: 'pdf',
          doc: 'pdf',
        },
      },
      {
        key: 'pdf-to-excel',
        icon: 'Excel' as const,
        title: t('Tools.convert.subMenu.pdfToExcel.title'),
        meta: {
          title: t('Tools.convert.subMenu.pdfToExcel.meta.title'),
          description: t('Tools.convert.subMenu.pdfToExcel.meta.description'),
        },
        link: 'pdf-to-excel',
        otherLinks: ['pdf-to-excel-converter'],
        toolInfo: {
          title: t('Tools.convert.subMenu.pdfToExcel.toolInfo.title'),
          description: t(
            'Tools.convert.subMenu.pdfToExcel.toolInfo.description'
          ),
        },
        acceptedInput: PDF_TO_EXCEL_FILE_TYPES,
        outputForInput: {
          pdf: 'xlsx',
        },
      },
      {
        key: 'excel-to-pdf',
        icon: 'Excel' as const,
        title: t('tools_data.menu.convert_to_pdf.tools.excel_to_pdf.title'),
        meta: {
          title: t('tools_data.menu.convert_to_pdf.tools.excel_to_pdf.title'),
          description: t(
            'tools_data.menu.convert_to_pdf.tools.excel_to_pdf.description'
          ),
        },
        link: 'excel-to-pdf',
        otherLinks: ['excel-to-pdf-converter'],
        toolInfo: {
          title: t('tools_data.menu.convert_to_pdf.tools.excel_to_pdf.title'),
          description: t(
            'tools_data.menu.convert_to_pdf.tools.excel_to_pdf.description'
          ),
        },
        acceptedInput: EXCEL_TO_PDF_FILE_TYPES,
        outputForInput: {
          xlsx: 'pdf',
          xls: 'pdf',
        },
      },
      {
        key: 'pdf-to-ppt',
        icon: 'PowerPoint' as const,
        title: t('Tools.convert.subMenu.pdfToPpt.title'),
        meta: {
          title: t('Tools.convert.subMenu.pdfToPpt.meta.title'),
          description: t('Tools.convert.subMenu.pdfToPpt.meta.description'),
        },
        link: 'pdf-to-ppt',
        otherLinks: ['pdf-to-ppt-converter'],
        toolInfo: {
          title: t('Tools.convert.subMenu.pdfToPpt.toolInfo.title'),
          description: t('Tools.convert.subMenu.pdfToPpt.toolInfo.description'),
        },
        acceptedInput: PDF_TO_POWERPOINT_FILE_TYPES,
        outputForInput: {
          pdf: 'pptx',
        },
      },
      {
        key: 'ppt-to-pdf',
        icon: 'PowerPoint' as const,
        title: t(
          'tools_data.menu.convert_to_pdf.tools.powerpoint_to_pdf.title'
        ),
        meta: {
          title: t(
            'tools_data.menu.convert_to_pdf.tools.powerpoint_to_pdf.title'
          ),
          description: t(
            'tools_data.menu.convert_to_pdf.tools.powerpoint_to_pdf.description'
          ),
        },
        link: 'ppt-to-pdf',
        otherLinks: ['ppt-to-pdf-converter'],
        toolInfo: {
          title: t(
            'tools_data.menu.convert_to_pdf.tools.powerpoint_to_pdf.title'
          ),
          description: t(
            'tools_data.menu.convert_to_pdf.tools.powerpoint_to_pdf.description'
          ),
        },
        acceptedInput: POWERPOINT_TO_PDF_FILE_TYPES,
        outputForInput: {
          pptx: 'pdf',
          ppt: 'pdf',
        },
      },
      {
        key: 'pdf-to-jpg',
        icon: 'JpegToPdf24' as const,
        title: t('Tools.convert.subMenu.pdfToJpg.title'),
        meta: {
          title: t('Tools.convert.subMenu.pdfToJpg.meta.title'),
          description: t('Tools.convert.subMenu.pdfToJpg.meta.description'),
        },
        link: 'pdf-to-jpg',
        otherLinks: ['pdf-to-image-converter'],
        acceptedInput: PDF_TO_IMAGE_FILE_TYPES,
        outputForInput: {
          pdf: 'jpeg',
        },
        toolInfo: {
          title: t('Tools.convert.subMenu.pdfToJpg.toolInfo.title'),
          description: t('Tools.convert.subMenu.pdfToJpg.toolInfo.description'),
        },
      },
      {
        key: 'jpg-to-pdf',
        icon: 'JpegToPdf24' as const,
        title: t('tools_data.menu.convert_to_pdf.tools.image_to_pdf.title'),
        meta: {
          title: t('tools_data.menu.convert_to_pdf.tools.image_to_pdf.title'),
          description: t(
            'tools_data.menu.convert_to_pdf.tools.image_to_pdf.description'
          ),
        },
        link: 'jpg-to-pdf',
        otherLinks: ['image-to-pdf-converter'],
        acceptedInput: IMAGE_TO_PDF_FILE_TYPES,
        outputForInput: {
          jpeg: 'pdf',
          jpg: 'pdf',
          png: 'pdf',
        },
        toolInfo: {
          title: t('tools_data.menu.convert_to_pdf.tools.image_to_pdf.title'),
          description: t(
            'tools_data.menu.convert_to_pdf.tools.image_to_pdf.description'
          ),
        },
      },
      {
        key: 'pdf-ocr',
        icon: 'PdfOcr' as const,
        title: t('Tools.convert.subMenu.pdfOcr.title'),
        meta: {
          title: t('Tools.convert.subMenu.pdfOcr.meta.title'),
          description: t('Tools.convert.subMenu.pdfOcr.meta.description'),
        },
        link: 'pdf-ocr',
        acceptedInput: ['pdf'],
        outputForInput: {
          pdf: 'pdf',
        },
        toolInfo: {
          title: t('Tools.convert.subMenu.pdfOcr.toolInfo.title'),
          description: t('Tools.convert.subMenu.pdfOcr.toolInfo.description'),
        },
      },
    ],
  },
  {
    key: 'organize',
    title: t('Tools.organize.title'),
    link: '/organize-pdf',
    icon: 'OrganizeSide' as const,
    className: '[&_path]:stroke-[#AA67FF]',
    subMenu: [
      {
        icon: 'RotatePdf24' as const,
        title: t('Tools.organize.subMenu.rotatePdf.title'),
        meta: {
          title: t('Tools.organize.subMenu.rotatePdf.meta.title'),
          description: t('Tools.organize.subMenu.rotatePdf.meta.description'),
        },
        status: 'coming_soon',
        link: 'rotate-pdf',
        toolInfo: {
          title: t('Tools.organize.subMenu.rotatePdf.toolInfo.title'),
          description: t(
            'Tools.organize.subMenu.rotatePdf.toolInfo.description'
          ),
        },
        acceptedInput: PDF_ONLY_FILE_TYPES,
      },
      {
        icon: 'SplitPdf' as const,
        title: t('Tools.organize.subMenu.splitPdf.title'),
        meta: {
          title: t('Tools.organize.subMenu.splitPdf.meta.title'),
          description: t('Tools.organize.subMenu.splitPdf.meta.description'),
        },
        status: 'available',
        link: 'split-pdf',
        toolInfo: {
          title: t('Tools.organize.subMenu.splitPdf.toolInfo.title'),
          description: t(
            'Tools.organize.subMenu.splitPdf.toolInfo.description'
          ),
        },
        acceptedInput: PDF_ONLY_FILE_TYPES,
      },
      {
        icon: 'MergePdf' as const,
        title: t('Tools.organize.subMenu.mergePdf.title'),
        meta: {
          title: t('Tools.organize.subMenu.mergePdf.meta.title'),
          description: t('Tools.organize.subMenu.mergePdf.meta.description'),
        },
        status: 'coming_soon',
        link: 'merge-pdf',
        otherLinks: [
          'merge-jpg-to-pdf',
          'combine-jpg-to-pdf',
          'merge-png-to-pdf',
        ],
        toolInfo: {
          title: t('Tools.organize.subMenu.mergePdf.toolInfo.title'),
          description: t(
            'Tools.organize.subMenu.mergePdf.toolInfo.description'
          ),
        },
        acceptedInput: MERGE_PDF_FILE_TYPES,
      },
      {
        icon: 'DeletePdfPages' as const,
        title: t('Tools.organize.subMenu.deletePdfPages.title'),
        meta: {
          title: t('Tools.organize.subMenu.deletePdfPages.meta.title'),
          description: t(
            'Tools.organize.subMenu.deletePdfPages.meta.description'
          ),
        },
        status: 'coming_soon',
        link: 'delete-pdf-pages',
        toolInfo: {
          title: t('Tools.organize.subMenu.deletePdfPages.toolInfo.title'),
          description: t(
            'Tools.organize.subMenu.deletePdfPages.toolInfo.description'
          ),
        },
        acceptedInput: PDF_ONLY_FILE_TYPES,
      },
      {
        icon: 'ExtractPdfPages' as const,
        title: t('Tools.organize.subMenu.extractPdfPages.title'),
        meta: {
          title: t('Tools.organize.subMenu.extractPdfPages.meta.title'),
          description: t(
            'Tools.organize.subMenu.extractPdfPages.meta.description'
          ),
        },
        status: 'available',
        link: 'extract-pdf-pages',
        toolInfo: {
          title: t('Tools.organize.subMenu.extractPdfPages.toolInfo.title'),
          description: t(
            'Tools.organize.subMenu.extractPdfPages.toolInfo.description'
          ),
        },
        acceptedInput: PDF_ONLY_FILE_TYPES,
      },
    ],
  },
  {
    key: 'edit',
    title: t('Tools.edit.title'),
    link: '/edit-pdf',
    icon: 'EditSide' as const,
    className: '[&_path]:stroke-[#1BCFC4]',
    subMenu: [
      {
        icon: 'PdfAnnotator' as const,
        title: t('Tools.edit.subMenu.annotate.title'),
        meta: {
          title: t('Tools.edit.subMenu.annotate.meta.title'),
          description: t('Tools.edit.subMenu.annotate.meta.description'),
        },
        status: 'available',
        link: 'annotate-pdf',
        otherLinks: ['pdf-annotator'],
        toolInfo: {
          title: t('Tools.edit.subMenu.annotate.toolInfo.title'),
          description: t('Tools.edit.subMenu.annotate.toolInfo.description'),
        },
        acceptedInput: PDF_ONLY_FILE_TYPES,
        outputForInput: {
          pdf: 'pdf',
        },
      },
      {
        icon: 'EditPdf24' as const,
        title: t('Tools.edit.subMenu.editText.title'),
        isPro: true,
        meta: {
          title: t('Tools.edit.subMenu.editText.meta.title'),
          description: t('Tools.edit.subMenu.editText.meta.description'),
        },
        status: 'available',
        link: 'edit-pdf',
        otherLinks: ['pdf-editor'],
        toolInfo: {
          title: t('Tools.edit.subMenu.editText.toolInfo.title'),
          description: t('Tools.edit.subMenu.editText.toolInfo.description'),
        },
        acceptedInput: PDF_ONLY_FILE_TYPES,
        outputForInput: {
          pdf: 'pdf',
        },
      },
      {
        icon: 'CropPdf' as const,
        title: t('Tools.edit.subMenu.cropPdf.title'),
        meta: {
          title: t('Tools.edit.subMenu.cropPdf.meta.title'),
          description: t('Tools.edit.subMenu.cropPdf.meta.description'),
        },
        status: 'available',
        link: 'crop-pdf',
        toolInfo: {
          title: t('Tools.edit.subMenu.cropPdf.toolInfo.title'),
          description: t('Tools.edit.subMenu.cropPdf.toolInfo.description'),
        },
        acceptedInput: [
          'pdf',
          'docx',
          'doc',
          'xlsx',
          'xls',
          'pptx',
          'ppt',
          'jpeg',
          'jpg',
          'png',
        ],
      },
      {
        icon: 'PdfReader' as const,
        title: t('Tools.edit.subMenu.pdfReader.title'),
        meta: {
          title: t('Tools.edit.subMenu.pdfReader.meta.title'),
          description: t('Tools.edit.subMenu.pdfReader.meta.description'),
        },
        status: 'available',
        link: 'pdf-reader',
        toolInfo: {
          title: t('Tools.edit.subMenu.pdfReader.toolInfo.title'),
          description: t('Tools.edit.subMenu.pdfReader.toolInfo.description'),
        },
        acceptedInput: [
          'pdf',
          'docx',
          'doc',
          'xlsx',
          'xls',
          'pptx',
          'ppt',
          'jpeg',
          'jpg',
          'png',
        ],
      },
      {
        icon: 'NumberPages' as const,
        title: t('Tools.edit.subMenu.numberPages.title'),
        meta: {
          title: t('Tools.edit.subMenu.numberPages.meta.title'),
          description: t('Tools.edit.subMenu.numberPages.meta.description'),
        },
        status: 'available',
        link: 'number-pages',
        toolInfo: {
          title: t('Tools.edit.subMenu.numberPages.toolInfo.title'),
          description: t('Tools.edit.subMenu.numberPages.toolInfo.description'),
        },
        acceptedInput: [
          'pdf',
          'docx',
          'doc',
          'xlsx',
          'xls',
          'pptx',
          'ppt',
          'jpeg',
          'jpg',
          'png',
        ],
      },
      {
        icon: 'RedactPdf' as const,
        title: t('Tools.edit.subMenu.redactPdf.title'),
        meta: {
          title: t('Tools.edit.subMenu.redactPdf.meta.title'),
          description: t('Tools.edit.subMenu.redactPdf.meta.description'),
        },
        status: 'available',
        link: 'redact-pdf',
        toolInfo: {
          title: t('Tools.edit.subMenu.redactPdf.toolInfo.title'),
          description: t('Tools.edit.subMenu.redactPdf.toolInfo.description'),
        },
        acceptedInput: [
          'pdf',
          'docx',
          'doc',
          'xlsx',
          'xls',
          'pptx',
          'ppt',
          'jpeg',
          'jpg',
          'png',
        ],
      },
      {
        icon: 'WatermarkPdf' as const,
        title: t('Tools.edit.subMenu.watermarkPdf.title'),
        meta: {
          title: t('Tools.edit.subMenu.watermarkPdf.meta.title'),
          description: t('Tools.edit.subMenu.watermarkPdf.meta.description'),
        },
        status: 'available',
        link: 'watermark-pdf',
        toolInfo: {
          title: t('Tools.edit.subMenu.watermarkPdf.toolInfo.title'),
          description: t(
            'Tools.edit.subMenu.watermarkPdf.toolInfo.description'
          ),
        },
        acceptedInput: [
          'pdf',
          'docx',
          'doc',
          'xlsx',
          'xls',
          'pptx',
          'ppt',
          'jpeg',
          'jpg',
          'png',
        ],
      },
    ],
  },
  {
    key: 'sign',
    title: t('Tools.sign.title'),
    meta: {
      title: t('Tools.sign.meta.title'),
      description: t('Tools.sign.meta.description'),
    },
    link: '/sign-pdf',
    otherLinks: ['esign-pdf', 'sign'],
    icon: 'SignSide' as const,
    acceptedInput: PDF_ONLY_FILE_TYPES,
    outputForInput: {
      pdf: 'pdf',
    },
    toolInfo: {
      title: t('Tools.sign.toolInfo.title'),
      description: t('Tools.sign.toolInfo.description'),
    },
    className: '[&_path]:stroke-[#F43FE2]',
  },
  {
    key: 'ai',
    title: t('Tools.ai.title'),
    link: '/ai-pdf',
    icon: 'AiSide' as const,
    className: '[&_path]:stroke-[#35C2FF]',
    subMenu: [
      {
        icon: 'ChatWithPdf' as const,
        title: t('Tools.ai.subMenu.chatWithPdf.title'),
        meta: {
          title: t('Tools.ai.subMenu.chatWithPdf.meta.title'),
          description: t('Tools.ai.subMenu.chatWithPdf.meta.description'),
        },
        status: 'coming_soon',
        link: 'chat-with-pdf',
        toolInfo: {
          title: t('Tools.ai.subMenu.chatWithPdf.toolInfo.title'),
          description: t('Tools.ai.subMenu.chatWithPdf.toolInfo.description'),
        },
        acceptedInput: [
          'pdf',
          'docx',
          'doc',
          'xlsx',
          'xls',
          'pptx',
          'ppt',
          'jpeg',
          'jpg',
          'png',
        ],
      },
      {
        icon: 'AiPdfSummarizer' as const,
        title: t('Tools.ai.subMenu.aiPdfSummarizer.title'),
        meta: {
          title: t('Tools.ai.subMenu.aiPdfSummarizer.meta.title'),
          description: t('Tools.ai.subMenu.aiPdfSummarizer.meta.description'),
        },
        status: 'coming_soon',
        link: 'ai-pdf-summarizer',
        toolInfo: {
          title: t('Tools.ai.subMenu.aiPdfSummarizer.toolInfo.title'),
          description: t(
            'Tools.ai.subMenu.aiPdfSummarizer.toolInfo.description'
          ),
        },
        acceptedInput: [
          'pdf',
          'docx',
          'doc',
          'xlsx',
          'xls',
          'pptx',
          'ppt',
          'jpeg',
          'jpg',
          'png',
        ],
      },
      {
        icon: 'TranslatePdf' as const,
        title: t('Tools.ai.subMenu.translatePdf.title'),
        meta: {
          title: t('Tools.ai.subMenu.translatePdf.meta.title'),
          description: t('Tools.ai.subMenu.translatePdf.meta.description'),
        },
        status: 'available',
        link: 'translate-pdf',
        toolInfo: {
          title: t('Tools.ai.subMenu.translatePdf.toolInfo.title'),
          description: t('Tools.ai.subMenu.translatePdf.toolInfo.description'),
        },
        acceptedInput: [
          'pdf',
          'docx',
          'doc',
          'xlsx',
          'xls',
          'pptx',
          'ppt',
          'jpeg',
          'jpg',
          'png',
        ],
      },
    ],
  },
  {
    key: 'more',
    title: t('Tools.more.title'),
    meta: {
      title: t('Tools.more.meta.title'),
      description: t('Tools.more.meta.description'),
    },
    link: '/more',
    icon: 'MoreSide' as const,
    className: '[&_path]:stroke-[#FF678C]',
    subMenu: [
      {
        icon: 'UnlockPdf' as const,
        title: t('Tools.more.subMenu.unlockPdf.title'),
        meta: {
          title: t('Tools.more.subMenu.unlockPdf.meta.title'),
          description: t('Tools.more.subMenu.unlockPdf.meta.description'),
        },
        status: 'available',
        link: 'unlock-pdf',
        toolInfo: {
          title: t('Tools.more.subMenu.unlockPdf.toolInfo.title'),
          description: t('Tools.more.subMenu.unlockPdf.toolInfo.description'),
        },
        acceptedInput: PDF_ONLY_FILE_TYPES,
      },
      {
        icon: 'ProtectPdf' as const,
        title: t('Tools.more.subMenu.protectPdf.title'),
        meta: {
          title: t('Tools.more.subMenu.protectPdf.meta.title'),
          description: t('Tools.more.subMenu.protectPdf.meta.description'),
        },
        status: 'available',
        link: 'protect-pdf',
        toolInfo: {
          title: t('Tools.more.subMenu.protectPdf.toolInfo.title'),
          description: t('Tools.more.subMenu.protectPdf.toolInfo.description'),
        },
        acceptedInput: PDF_ONLY_FILE_TYPES,
      },
      {
        icon: 'FlattenPdf' as const,
        title: t('Tools.more.subMenu.flattenPdf.title'),
        meta: {
          title: t('Tools.more.subMenu.flattenPdf.meta.title'),
          description: t('Tools.more.subMenu.flattenPdf.meta.description'),
        },
        status: 'coming_soon',
        link: 'flatten-pdf',
        toolInfo: {
          title: t('Tools.more.subMenu.flattenPdf.toolInfo.title'),
          description: t('Tools.more.subMenu.flattenPdf.toolInfo.description'),
        },
        acceptedInput: [
          'pdf',
          'docx',
          'doc',
          'xlsx',
          'xls',
          'pptx',
          'ppt',
          'jpeg',
          'jpg',
          'png',
        ],
      },
    ],
  },
];

export const TOOL_APP_PAGE_OVERRIDES: Record<string, string> = {
  'protect-pdf': 'edit-pdf',
  'unlock-pdf': 'edit-pdf',
};

export const getToolAppUrl = (parentLink: string, tool: string) =>
  `/app/${TOOL_APP_PAGE_OVERRIDES[tool] ?? parentLink.replace(/^\/+/, '')}?tool=${tool}`;

export const inactiveTools = [
  'pdf-ocr',
  // 'compress',
  // 'pdf-converter',
  'chat-with-pdf',
  'ai-pdf-summarizer',
  'translate-pdf',
  // 'unlock-pdf',
  'flatten-pdf',
  // 'rotate-pdf',
  // 'split-pdf',
  // 'merge-pdf',
  // 'delete-pdf-pages',
  // 'extract-pdf-pages',
  'crop-pdf',
  'pdf-reader',
  'number-pages',
  'redact-pdf',
  'watermark-pdf',
  // 'sign',
];

export const inactiveToolsSlug = [
  'pdf-ocr',
  // 'compress-pdf',
  // 'pdf-converter',
  'chat-with-pdf',
  'ai-pdf-summarizer',
  'translate-pdf',
  // 'unlock-pdf',
  // 'protect-pdf',
  'flatten-pdf',
  // 'rotate-pdf',
  // 'split-pdf',
  // 'merge-pdf',
  // 'delete-pdf-pages',
  // 'extract-pdf-pages',
  'crop-pdf',
  'pdf-reader',
  'number-pages',
  'redact-pdf',
  'watermark-pdf',
  // "esign-pdf"
];

export const TOOL_FILE_SIZE = [
  {
    type: 'pdf',
    size: 40,
  },
  {
    type: 'doc',
    size: 15,
  },
  {
    type: 'docx',
    size: 15,
  },
  {
    type: 'jpg',
    size: 40,
  },
  {
    type: 'jpeg',
    size: 40,
  },
  {
    type: 'png',
    size: 40,
  },
  {
    type: 'xls',
    size: 15,
  },
  {
    type: 'xlsx',
    size: 15,
  },
  {
    type: 'ppt',
    size: 15,
  },
  {
    type: 'pptx',
    size: 15,
  },
];
